import { render, staticRenderFns } from "./AddRemitterGroupComponent.vue?vue&type=template&id=cd3946a0"
import script from "./AddRemitterGroupComponent.vue?vue&type=script&lang=js"
export * from "./AddRemitterGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports